import React, { useState, useEffect, useCallback, memo } from 'react';
import { connect } from 'react-redux';
import { List, fromJS } from 'immutable';
import moment from 'moment';

import MarkMailingCompletedPopup from '../../components/Popup/MarkMailingCompletedPopup';
import targetStatuses from '../../utils/targetStatuses';
import { fetchTargetStatuses } from '../../actions/statuses';
import { usePopupContext } from '../../contexts/PopupContext';

const MarkMailingCompletedPopupContainer = ({ popup, fetchTargetStatuses }) => {
  const { closePopup, openPopup, updatePopupFormData, startPopupLoading, endPopupLoading } = usePopupContext();
  const [statuses, setStatuses] = useState(List());

  useEffect(() => {
    fetchTargetStatuses(({ response: { data } }) => {
      setStatuses(targetStatuses(fromJS(data)));
    });

    updatePopupFormData({
      date: moment(),
      status: {
        selected: {
          name: '4',
          value: '4',
        },
      },
    });
  }, []);

  const handleSuccessResponse = useCallback(
    ({ errors }) => {
      if (errors && errors.length > 0) {
        const updateListStatuses = popup.getIn(['props', 'updateListStatuses'], () => {});
        const eventIds = errors.map(({ eventId }) => eventId);
        const message = errors.reduce((accumulator, error) => {
          accumulator += `${error.error}\n`;

          return accumulator;
        }, '');

        openPopup('ConfirmPopup', {
          message,
          header: 'The state of the list has been changed',
          submessage: 'Click "Update" to remove these targets from the list',
          yes: 'Update',
          no: 'Cancel',
          danger: false,
          onOk: () => {
            updateListStatuses(eventIds);
            closePopup();
          },
          onCancel: () => closePopup(),
        });
      }
    },
    [popup, openPopup, closePopup],
  );

  const handleDateChange = useCallback(
    ({ target }) => {
      if (target.value.isValid()) {
        updatePopupFormData({
          [target.name]: target.value,
        });
      }
    },
    [updatePopupFormData],
  );

  const handleStatusChange = useCallback(
    event => {
      const { value } = event.target;

      updatePopupFormData({
        status: {
          selected: {
            name: value,
            value,
          },
        },
      });
    },
    [updatePopupFormData],
  );

  const handleUpdate = useCallback(() => {
    const onUpdate = popup.getIn(['props', 'onUpdate'], () => {});
    const refreshGrid = popup.getIn(['props', 'refreshGrid'], () => {});

    onUpdate(popup.get('formData'), {
      beforeStart: startPopupLoading,
      afterSuccess: ({ response }) => {
        endPopupLoading();
        refreshGrid();
        handleSuccessResponse(response.skipped);
      },
      skipGlobalErrorHandler: true,
      afterError: ({ responseBody }) => {
        endPopupLoading(responseBody);
      },
    });
  }, [popup, startPopupLoading, endPopupLoading, handleSuccessResponse]);

  const handleClose = useCallback(() => {
    closePopup();
  }, [closePopup]);

  return (
    <MarkMailingCompletedPopup
      formData={popup.get('formData')}
      isPopupFetching={popup.get('isPopupFetching')}
      isPopupFetchingError={popup.get('isPopupFetchingError')}
      onClose={handleClose}
      onDateChange={handleDateChange}
      onStatusChange={handleStatusChange}
      onUpdate={handleUpdate}
      statusCodes={statuses}
    />
  );
};

export { MarkMailingCompletedPopupContainer };
export default connect(
  (state, props) => ({
    ...props,
  }),
  { fetchTargetStatuses },
)(memo(MarkMailingCompletedPopupContainer));
